import { StatusData, StatusResource } from "store/Slices/Status/statusSlice";

export type StatusResponseObject = {
  id: string;
  etat: string;
  occupe: boolean;
  stacks: boolean;
  inventaire: boolean;
  palettes: boolean;
  cages: boolean;
  operEnAttente: boolean;
  typeReservation: string;
  modeOperation: string;
};

export type StatusResponse = {
  statusResponse: JSON;
};

export function transformStatusResponseListToResource(
  statusResponse: StatusResponse
): StatusResource {
  const statusResource: StatusResource = {
    statusPlan: [],
  };
  const statusList = statusResponse as unknown as StatusResponseObject[];
  statusList.forEach(statusElement => {
    statusResource.statusPlan.push(
      transformStatusResponseElementToResource(statusElement)
    );
  });
  return statusResource;
}

export function transformStatusResponseElementToResource(
  statusElement: StatusResponseObject
): StatusData {
  return {
    id: statusElement.id,
    status: statusElement.etat,
    isOccupied: statusElement.occupe,
    hasStacks: statusElement.stacks,
    hasInventory: statusElement.inventaire,
    hasPallet: statusElement.palettes,
    hasCage: statusElement.cages,
    isOperationInProgress: statusElement.operEnAttente,
    reservationType: statusElement.typeReservation,
    operationType: statusElement.modeOperation,
  };
}
